import { createContext, useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom'
import jwtDecode from 'jwt-decode'
import Axios from 'axios'
import Swal from 'sweetalert2'
import { useDispatch } from "react-redux"

export const AuthContext = createContext()

export default function AuthProvider({children}) {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    let token = sessionStorage.getItem('jwt')

    const [client, setClient] = useState()

    /**
     * Loguea un usuario y genera el token
     * @param {*} clientCredentials
     */
    const loginClient = async (clientCredentials) => {
        const options = {
            headers: { "Access-Control-Allow-Origin": "*" },
        }
        const result = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/login/in', { email: clientCredentials.email, password: clientCredentials.password }, options)
        
        if(result?.data?.message !== 'notverified'){
            sessionStorage.setItem('jwt', result.data['token'])
            token = sessionStorage.getItem('jwt')

            if (token!=='undefined') {
                setClient(jwtDecode(token))
                let rol = jwtDecode(token).rol
                let firsttime = jwtDecode(token).firsttime
                sessionStorage.setItem('firsttime', firsttime)

                if(rol === 'Superadmin'){
                    navigate('/admin/dashboard')
                }else{
                    if(rol === 'Candidate'){
                        if(firsttime === true){
                            navigate('/candidate/profile')
                        }else{
                            navigate('/candidate/dashboard')
                        }
                    } else if(rol === 'School'){
                        if(firsttime === true){
                            navigate('/school/profile')
                        }else{
                            navigate('/school/dashboard')
                        }
                    } else {
                        navigate('/multischool/dashboard')
                    }
                }
            } else {
                // Mostramos el popup informativo
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonColor: '#3085d6',
                    buttonsStyling: false,
                    confirmButtonText: 'Cerrar',
                    icon: 'error',
                    text: 'Credenciales incorrectas'
                })         
            }
        }else{
            navigate('/activation/'+result?.data?.idUser)
        }
    }

    // Desloguea un usuario eliminando token y seteando el usuario a null
    const logout = () => {
        setClient(null);
        dispatch({ type: 'USER_LOGOUT'})
        sessionStorage.removeItem('jwt')
        navigate('/')
    }

    // Comprueba el estado del usuario y devuelve true o false
    const isLogged = () => !!client;

    // Variables accesibles desde cualquier componente
    const contextValue = {client, isLogged, loginClient, logout}

    /**
     * Usamos el useEffect para comprobar que el token no ha cambiado
     */
    // token = sessionStorage.getItem('jwt')
    useEffect(() =>{
        try {
            setClient(jwtDecode(token))
        } catch (error) {
            setClient(null);
            sessionStorage.removeItem('jwt')
        }
    }, [token]);

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    )
}
